<div class="header-wrapper">
	<h1>{{page?.entityLabel }}</h1>
	<span class="description" [innerHtml]="page?.description?.value"></span>
</div>
